import { PropsWithChildren } from "react";
import Markdown, { MarkdownProps } from "react-native-markdown-display";
import { styled, Text, TextProps, View } from "tamagui";

import { RenderMd } from "./custom-md";

const CardTitle: React.FC<TextProps> = (props) => {
  return (
    <Text
      fontFamily={"$subtitle"}
      fontWeight={"$7"}
      fontSize={"$7.3"}
      lineHeight={"$7.3"}
      textAlign={"center"}
      $sm={{ fontSize: "$7", fontWeight: "$6", lineHeight: "$7" }}
      {...props}
    />
  );
};

const CardSubtitle: React.FC<TextProps> = (props) => (
  <Text
    fontFamily={"$body"}
    fontWeight={"$4"}
    fontSize={"$4"}
    lineHeight={"$3"}
    $gtMd={{ fontSize: "$5", fontWeight: "$4", lineHeight: "$5" }}
    {...props}
  />
);

const CardTitleMd: React.FC<
  PropsWithChildren & MarkdownProps & { font?: "md" | "lg" }
> = ({ children, font = "lg", ...rest }) => {
  return (
    <Markdown
      style={{
        ...(font === "lg"
          ? {
              body: {
                color: "#23252A",
                fontFamily: "Fixel Text",
                fontWeight: 600,
                fontSize: 24,
                lineHeight: 30,
              },
              strong: {
                color: "#23252A",
                fontFamily: "Fixel Text",
                fontWeight: 600,
                fontSize: 24,
                lineHeight: 30,
              },
            }
          : {
              body: {
                color: "#23252A",
                fontFamily: "Fixel Text",
                fontWeight: 600,
                fontSize: 20,
                lineHeight: 25,
              },
              strong: {
                color: "#23252A",
                fontFamily: "Fixel Text",
                fontWeight: 600,
                fontSize: 20,
                lineHeight: 25,
              },
            }),
        paragraph: {
          justifyContent: "center",
        },
      }}
      {...rest}
    >
      {children}
    </Markdown>
  );
};

export const CardBase = styled(View, {
  name: "Card",
  variants: {
    variant: {
      default: {
        backgroundColor: "white",
        borderWidth: "$0.2",
        borderColor: "$gray-600",
      },
      gray: {
        backgroundColor: "$gray-50",
      },
      borderless: {
        borderWidth: 0,
      },
    },

    size: {
      md: {
        padding: "$6",
      },
      sm: {
        padding: "$3",
      },
    },

    rounded: {
      lg: {
        borderRadius: "$9",
      },
      md: {
        borderRadius: "$9",
      },
      none: {
        borderRadius: 0,
      },
    },

    shadow: {
      md: {
        shadowColor: "$gray-300",
        shadowOffset: { width: 0, height: 3 },
        shadowOpacity: 1,
        shadowRadius: 0,
      },
      none: {},
    },
  } as const,

  defaultVariants: {
    variant: "default",
    size: "md",
    rounded: "lg",
  },
});

CardBase.displayName = "Card";

export const Card = Object.assign(CardBase, {
  Title: CardTitle,
  TitleMd: CardTitleMd,
  Subtitle: CardSubtitle,
  RenderMd,
});
